import script from "./WizardProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./WizardProgressBar.vue?vue&type=style&index=0&id=6a98c574&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a98c574"]])

export default __exports__